import React, { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface ScrollToTopBottomProps {
  primaryColor?: string;
}

const ScrollToTopBottom: React.FC<ScrollToTopBottomProps> = ({ 
  primaryColor = '#F97316' 
}) => {
  const [showButton, setShowButton] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // Show button after scrolling 300px
      setShowButton(scrollTop > 300);
      
      // Check if we're near the bottom (within 100px)
      setIsAtBottom(scrollTop + windowHeight >= documentHeight - 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth'
    });
  };

  if (!showButton) return null;

  return (
    <div className="fixed left-4 bottom-4 z-50 flex flex-col gap-2">
      {!isAtBottom && (
        <button
          onClick={scrollToTop}
          className="p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 text-white"
          style={{ backgroundColor: primaryColor }}
          aria-label="Scroll to top"
        >
          <ChevronUp size={20} />
        </button>
      )}
      
      {!isAtBottom && (
        <button
          onClick={scrollToBottom}
          className="p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 text-white"
          style={{ backgroundColor: primaryColor }}
          aria-label="Scroll to bottom"
        >
          <ChevronDown size={20} />
        </button>
      )}
    </div>
  );
};

export default ScrollToTopBottom;